import { PotentialSearchActionSd } from './potential-search-action.sd';
import { PublisherSd } from './publisher.sd';

export class WebsiteSd {
  '@context' = 'http://schema.org';
  '@type' = 'WebSite';
  url: string;
  potentialAction: PotentialSearchActionSd;
  name = 'Boxdelivery';
  '@id' = '#Website';
  inLanguage = 'nl-BE';
  publisher: PublisherSd;

  constructor(baseUrl: string, logoUrl: string) {
    this.url = baseUrl;
    this.potentialAction = new PotentialSearchActionSd(baseUrl);
    this.publisher = new PublisherSd(baseUrl, logoUrl);
  }
}
